import React, { Component } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip } from 'recharts';
import moment from "moment-timezone";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

class CustomTooltip extends Component {
  render() {
      const { active, payload } = this.props;

      if (active && payload[0] !== undefined) {
        let value = parseFloat(payload[0].value);

        if(this.props.scorecardTypeId === 4)
        {
          value = this.getFormattedTimeValue(moment.duration(value, 'minutes'));
        }
        else if(this.props.scorecardTypeId === 3)
        {
         value += '%';
        }
        
        return (
          <div className="custom-tooltip">
           <p className="label" >{`${payload[0].payload.x.format('MM/DD/YYYY')}, ${value}`}</p>
          </div>
        );
      }
  
      return null;
    }

    getFormattedTimeValue(duration) {

      let result = "";
  
      let seconds = Math.abs(parseInt((duration/1000)%60, 10))
      , minutes = Math.abs(parseInt((duration/(1000*60))%60, 10))
      , hours = Math.abs(parseInt((duration/(1000*60*60))%24,10));
  
      hours = (hours < 10) ? "0" + hours : hours;
      minutes = (minutes < 10) ? "0" + minutes : minutes;
      seconds = (seconds < 10) ? "0" + seconds : seconds;
  
      result = hours >= 1 ? hours + ":" + minutes + ":" + seconds : minutes + ":" + seconds ;
  
      return result;
    }
}

export class ScorecardDataModule extends Component {
  componentDidMount() {
    this.props.onDataLoad();
  } 
      
  render() {
    let data = this.props.chartData;
    // isTablet = width < 1025
    // isPortraitOrientation = screen orientation is 90 degrees
    // isNotDesktop = any device that is not a desktop. UserAgent used here.
    let { isTablet, isPortraitOrientation, isNotDesktop } = this.props;
    return (
      data !== undefined && data.length > 0 ?
      <div
          style={{
            display: 'flex',
            flexDirection: 'column',           
            height: '65px',
            width: isTablet && isPortraitOrientation && !isNotDesktop ? 800 : 330,
            margin: '0 auto'
          }}
        >
        <div
          style={{
            flex: 'auto',
            maxHeight: '55px',
            maxWidth: isTablet && isPortraitOrientation && !isNotDesktop ? 800 : 330,
            margin: '0 0 5px'
          }}
        >
        <LineChart width={ isTablet && isPortraitOrientation && !isNotDesktop ? 800 : 330 } height={65} data={data[0]}>
          <XAxis dataKey="x" hide={true}/>
          <YAxis hide={true}/>
          <Tooltip content={<CustomTooltip scorecardTypeId={this.props.scorecardTypeId} timeFormatFunction={() => this.props.getFormattedTimeValue}/>}/>
          <Line connectNulls={true} type='monotone' dataKey='y' stroke='#5194E3' strokeWidth='2' fill='#015696' dot={{ stroke: '#015696' }}/>
        </LineChart>

        <div className="cf x-axis-label">
          <span className="data-module-chart-date-range l">{this.props.startDate.format("MM/DD")}</span>
          <span className="data-module-chart-date-range r">{this.props.endDate.format("MM/DD")}</span>
        </div>

      </div>

    </div>

    :
    ''
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isTablet: state.common.isTablet,
    isNotDesktop: state.common.isNotDesktop,
    isPortraitOrientation: state.common.isPortraitOrientation
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScorecardDataModule);



// WEBPACK FOOTER //
// ./src/features/scorecard/ScorecardDataModule.js